import { RouterProvider } from 'react-router-dom'
import { AppProviders } from '@/app/providers'
import { router } from '@/app/router'
import 'leaflet/dist/leaflet.css'

export default function App() {
  return <AppProviders><RouterProvider router={router} /></AppProviders>
}
